module.exports = __webpack_public_path__ + "static/media/product_list.a1f2c012.png";